<template>
  <searchable-object-selector
      ref="selector"
      :objects="sortedDepartments"
      :disabled="disabled"
      :placeholder="placeholder"
      @input="input"
      :value="value"
      :formatter="formatter"
      :state="state" />
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'department-selector',
  props: {
    value: Object,
    allowNull: {
      Boolean,
      default () {
        return false
      }
    },
    disabled: {
      Boolean,
      default () {
        return false
      }
    },
    size: String,
    placeholder: String,
    state: {
      Boolean,
      default () {
        return null
      }
    }
  },
  computed: {
    ...mapGetters({
      departments: 'meta/departments'
    }),
    sortedDepartments () {
      return this.departments.slice().sort((a, b) => a.code.localeCompare(b.code))
    }
  },
  methods: {
    input (v) {
      this.$emit('input', v)
    },
    selectById (id) {
      this.$refs.selector.selectById(id)
    },
    formatter: (i) => `${i.code}: ${i.name}`
  },
  mounted () {
    this.$store.dispatch('meta/load')
  }
}
</script>
